import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title, DomSanitizer } from '@angular/platform-browser';

import { LoginService } from '../../services/auth/login.service';
import { CoreConfigService } from '../../services/config/core-config.service';

@Component({
	selector: 'zx-login-page',
	templateUrl: './login-page.component.html',
	styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

	validateForm: FormGroup;
	authenticationError: boolean = false;
	
	qrcodeLogin: boolean = false;
	qrcodeUrl: any;
	private host: string;

	private _defaultAppTitle = "登录系统";
	private _defaultFooterText = "Copyright © 2018 \n版权所有";

	@Input("app-title") appTitle: string;
	@Input("app-logo") appLogo: string;
	@Input("ad-image") adImage: string;
	@Input("ad-image-style") adImageStyle: any;
	@Input("footer-image") footerImage: string;
	@Input("footer-text") footerText: string;
	@Input("background-image") backgroundImage: string;
	@Input("loginSuccess") loginSuccess: Function;
	@Input("loginFail") loginFail: Function;
	@Input("forgotRouterLink") forgotRouterLink: any;// = ['/fogot'];
	@Input("registerRouterLink") registerRouterLink: any;// = ['/register'];


	constructor(
		private activatedRoute: ActivatedRoute,
		private loginService: LoginService,
		private configService: CoreConfigService,
		private titleService: Title,
		private router: Router,
		private formBuilder: FormBuilder,
	) {
		this.loginForQrcode();
	}

	ngOnInit() {
		this.host = location.host;
		const config = this.configService.loginPage || {};

		this.appTitle = this.appTitle || config.appTitle || this._defaultAppTitle;
		this.appLogo = this.appLogo || config.appLogo;
		this.adImage = this.adImage || config.adImage;
		this.adImageStyle = this.adImageStyle || config.adImageStyle;
		this.footerImage = this.footerImage || config.footerImage;
		this.footerText = this.footerText || config.footerText || this._defaultFooterText;
		this.backgroundImage = this.backgroundImage || config.backgroundImage;
		this.loginSuccess = this.loginSuccess || config.loginSuccess;
		this.loginFail = this.loginFail || config.loginFail;
		this.forgotRouterLink = this.forgotRouterLink || config.forgotRouterLink;
		this.registerRouterLink = this.registerRouterLink || config.registerRouterLink;

		this.titleService.setTitle(this.appTitle);
		this.activatedRoute.data.subscribe(data => {
			if (data["loginAppTitle"]) this.appTitle = data["loginAppTitle"];
		});
		this.initForm();
	}

	initForm() {
		this.validateForm = this.formBuilder.group({
			username: [null, [Validators.required]],
			password: [null, [Validators.required]],
			rememberMe: [true],
		});
	}

	loginForQrcode() {
		let code = this.getQueryString('code') || this.activatedRoute.snapshot.queryParams['code'];
		if (!code) return;
		this.qrcodeLogin = true;
		let loginInfo: any = {
			grant_type: 'open_auth',
			action: 'action_login',
			auth_type: 'WEIXIN_WEB_APP'
		};
		loginInfo.auth_temp_key = code;
		this.login(loginInfo);
	}

	get appTitleStyle() {
		if (this.appTitle && (this.appTitle.length > 10 || this.appTitle.length <= 7)) {
			return { fontSize: (this.appTitle.length <= 7 ? 32 : 26 / this.appTitle.length * 10) + 'px' };
		}
		return null;
	}
	get pageStyle() {
		if (this.backgroundImage)
			return { background: `url('${this.backgroundImage}') 0% 0% / 100% 100%` };
		else
			return {};
	}

	submitForm(loginInfo?) {
		if (!loginInfo) {
			for (const i in this.validateForm.controls) {
				this.validateForm.controls[i].markAsDirty();
			}
			if (this.validateForm.status != 'VALID') return false;
		}
		let loginVaue = {};
		loginVaue = loginInfo ? loginInfo : this.validateForm.value;
		this.loginService.login(loginVaue)
			.then((account) => {
				this.authenticationError = false;

				if (this.loginSuccess) {
					try {
						this.loginSuccess(account, this.router);
						return;
					} catch (ex) { }
				}

				loginInfo ? window.location.href = '/gmp' : this.router.navigate(['/apps']);
			}).catch((error) => {
				this.authenticationError = true;
				if (this.loginFail) {
					try { this.loginFail(error, this.router); } catch (ex) { }
				}
			});
	}

	login(loginInfo?) {
		this.submitForm(loginInfo);
	}

	register() {
		let link = this.registerRouterLink;
		if (typeof link === 'string' || !Array.isArray(link)) link = [link];
		this.router.navigate(link);
	}

	forgot() {
		let link = this.forgotRouterLink;
		if (typeof link === 'string' || !Array.isArray(link)) link = [link];
		this.router.navigate(link);
	}

	private getQueryString(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
		if (r != null) return unescape(r[2]); return null;
	}
}